module.exports = __webpack_public_path__ + "static/media/spoer-p.f5ee7a43.mp3";